export const riskComplianceBasePath = (profileId) => `/customers/${profileId}/crif/risk-compliance`;

export const formatDunsNumber = (duns) => {
  if (!duns) return '';
  const digits = String(duns).replace(/\D/g, '');
  if (digits.length !== 9) return duns;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 9)}`;
};
